// Default site content used as fallback when no admin overrides exist.
export const DEFAULT_CONTENT = {
  company: {
    name: "Vissera",
    tagline: "Trusted Bridge for Gold & Silver",
    short: "Vissera is an Istanbul-based importer and exporter of investment-grade gold and silver, connecting refiners, banks, jewellers and institutional buyers across Europe, the Middle East, Asia and beyond.",
    email: "info [at] visseraco.com",
    phone: "+90 212 000 0000",
    address: "Levent, Istanbul, Türkiye",
    hours: "Mon–Fri, 09:00–18:00 (GMT+3)",
    logo_text_1: "VISSERA",
    logo_text_2: "PRECIOUS METALS",
  },
  images: {
    heroGold: "https://images.unsplash.com/photo-1610375461246-83df859d849d?auto=format&fit=crop&w=1400&q=85",
    istanbul: "https://images.unsplash.com/photo-1564507592333-c60657eea523?auto=format&fit=crop&w=1400&q=85",
    goldBars: "https://images.unsplash.com/photo-1610375461369-d613b564f4c4?auto=format&fit=crop&w=900&q=85",
    silverBars: "https://images.unsplash.com/photo-1610375461719-309cab1d2912?auto=format&fit=crop&w=900&q=85",
    coins: "https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?auto=format&fit=crop&w=900&q=85",
    granules: "https://images.unsplash.com/photo-1605792657660-596af9009e82?auto=format&fit=crop&w=900&q=85",
    logistics: "https://images.unsplash.com/photo-1605745341112-85968b19335b?auto=format&fit=crop&w=1400&q=85",
    vault: "https://images.unsplash.com/photo-1601597111158-2fceff292cdc?auto=format&fit=crop&w=1400&q=85",
    refinery: "https://images.unsplash.com/photo-1611174743420-3d7df880ce32?auto=format&fit=crop&w=1400&q=85",
    team: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1400&q=85",
    marketAnalysis: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=1400&q=85",
    istanbulBridge: "https://images.unsplash.com/photo-1541432901042-2d8bd64b4a9b?auto=format&fit=crop&w=1400&q=85",
  },
  hero: {
    eyebrow: "TRUSTED BRIDGE FOR GOLD & SILVER",
    headline_part1: "Gold and Silver, Moved with",
    headline_gold1: "Precision",
    headline_join: "and",
    headline_gold2: "Trust",
    subheadline: "Vissera is an Istanbul-based import and export house for investment-grade precious metals — serving refiners, jewellers, banks and institutional buyers worldwide.",
    cta_primary: "Request a Quote",
    cta_secondary: "Explore Our Products",
    badge_gold_label: "FINE GOLD",
    badge_gold_value: "999.9",
    badge_silver_label: "FINE SILVER",
    badge_silver_value: "999.0",
  },
  intro: {
    eyebrow: "A RELIABLE PARTNER",
    heading: "At the Heart of the\nGlobal Metals Trade",
    paragraph1: "Turkey sits where Europe, Asia and the Middle East meet — historically one of the most important arteries for the gold trade. Vissera builds on that position to source, import and export precious metals for clients who demand authenticity, discretion and dependable delivery.",
    paragraph2: "Whether you need a single certified consignment or an ongoing supply relationship, we make cross-border precious-metals trade straightforward.",
    badge_label: "BASED IN ISTANBUL",
    badge_text: "Connecting East and West with Trust",
    cta: "About Vissera",
  },
  ticker: {
    heading: "Live Metals Prices",
    updating: "Updating...",
    updated_prefix: "Updated",
    utc_suffix: "UTC",
  },
  home_copy: {
    services_eyebrow: "WHAT WE DO",
    services_title_part1: "End-to-End",
    services_title_highlight: "Precious Metals",
    services_title_part2: "Solutions",
    services_cta: "VIEW ALL SERVICES",
    products_eyebrow: "OUR PRODUCTS",
    products_title_part1: "Investment-Grade",
    products_title_highlight: "Gold & Silver",
    products_title_part2: "",
    products_cta: "VIEW ALL PRODUCTS",
    bottom_cta_eyebrow: "READY TO TRADE WITH CONFIDENCE?",
    bottom_cta_title: "Tell us what you need to buy, sell or move.",
    bottom_cta_body: "We'll respond with a clear, no-obligation quote — benchmarked to live market rates.",
    bottom_cta_button: "Contact Our Team",
  },
  services_page: {
    header_eyebrow: "OUR SERVICES",
    header_title_part1: "End-to-end",
    header_title_highlight: "precious-metals",
    header_title_part2: "trade",
    header_intro: "We manage the entire journey — sourcing, verification, documentation, customs and secure delivery — so you can transact with confidence.",
    process_eyebrow: "HOW IT WORKS",
    process_title_part1: "Trading with us is",
    process_title_highlight: "simple",
    process_title_part2: ".",
    cta_title: "Need a service not listed here? We tailor solutions to each client.",
    cta_button: "Talk to our team",
  },
  products_page: {
    header_eyebrow: "OUR PRODUCTS",
    header_title_part1: "Investment-grade",
    header_title_highlight: "gold & silver",
    header_title_part2: "",
    header_intro: "Vissera trades a full range of investment-grade and industrial gold and silver. All metals are supplied with appropriate certification and assay documentation. Standard purities are 99.5%+ for gold and 99.9%+ for silver; other specifications are available on request.",
    specs_eyebrow: "SPECIFICATIONS",
    specs_title: "What we supply",
    custom_eyebrow: "CUSTOM ORDER",
    custom_title: "Tell us your product, quantity and delivery destination.",
    custom_button: "Request a Quote",
  },
  products_specs: [
    { label: "Purity", value: "Gold 99.5% – 99.99%; Silver 99.9% – 99.99%" },
    { label: "Forms", value: "Bars, granules/grain, coins, semi-finished" },
    { label: "Certification", value: "Assay certificates and origin documentation included" },
    { label: "Custom Orders", value: "Specific weights, purities and packaging on request" },
  ],
  about_page: {
    header_eyebrow: "ABOUT US",
    header_title_prefix: "About",
    header_title_highlight_fallback: "Vissera",
    header_intro: "Vissera is a Turkey-based import and export company specialising in gold and silver. From our base in Istanbul, we serve a global client base of refiners, jewellery manufacturers, banks, investment firms and institutional buyers. Our business is built on a simple promise: every gram we trade is authentic, every transaction is transparent, and every shipment arrives secure and on time.",
    story_eyebrow: "OUR STORY",
    story_title: "Built on Turkey's gold-trading heritage",
    story_p1_fallback: "Vissera grew out of decades of involvement in Turkey's precious-metals trade — a market with centuries of history and a central role in the global flow of gold. What began as a domestic trading desk has grown into an international import-export operation moving metals across multiple continents.",
    story_p2: "Today we combine that heritage with disciplined modern practices: live-market pricing, independent assay verification, robust anti-money-laundering procedures and fully insured logistics. The result is a partner that international clients can rely on for both one-off consignments and long-term supply.",
    values_eyebrow: "OUR VALUES",
    values_title: "How we work — every transaction, every time",
    markets_eyebrow: "WHO WE WORK WITH",
    markets_title: "Trusted across the precious-metals supply chain.",
    markets_body: "With Turkey as our base, we trade actively across Europe, the Middle East and the Gulf, Central and South Asia, and East Asia — with selective reach into other markets on request.",
    cta_eyebrow: "START THE CONVERSATION",
    cta_title: "Ready to work together?",
    cta_button: "Contact our team",
  },
  about_mission_vision: [
    { label: "MISSION", title: "Make precious-metals trade secure, transparent and efficient.", body: "Connecting trusted suppliers with trusted buyers, and protecting the integrity of every transaction." },
    { label: "VISION", title: "A leading name in precious-metals import and export from Turkey.", body: "Recognised globally for purity, reliability and uncompromising compliance." },
  ],
  about_stats: [
    { value: "12+", label: "Years of Experience" },
    { value: "50+", label: "Countries Served" },
    { value: "250+", label: "Active Partners" },
    { value: "1,200+", label: "Shipments Completed" },
    { value: "$2B+", label: "Annual Volume Traded" },
  ],
  contact_page: {
    header_eyebrow: "GET IN TOUCH",
    header_title_part1: "Tell us what you need to",
    header_title_highlight: "buy, sell or move",
    header_title_part2: ".",
    header_intro: "Our team will respond promptly with a clear, no-obligation quote benchmarked to live market rates.",
    form_title: "Request a Quote",
    form_required_note: "All fields marked * are required.",
    success_title: "Thank you.",
    success_body: "We've received your enquiry and our team will be in touch within one business day.",
    success_button: "Send another enquiry",
    privacy_note: "By submitting this form you agree to our Privacy Policy. We use your details only to respond to your enquiry.",
    submit_label: "Send Enquiry",
    submitting_label: "Sending…",
    contact_card_eyebrow: "CONTACT",
    contact_card_title: "Reach our team",
    response_eyebrow: "FAST RESPONSE",
    response_body: "Enquiries received during trading hours are typically answered within one business day. For urgent matters, please call.",
    faqs_eyebrow: "FREQUENTLY ASKED",
    faqs_title_part1: "Quick answers to common",
    faqs_title_highlight: "trade questions",
    faqs_title_part2: "",
  },
  compliance_page: {
    header_eyebrow: "COMPLIANCE & RESPONSIBLE SOURCING",
    header_title_part1: "Compliance is",
    header_title_highlight: "fundamental",
    header_title_part2: ", not optional",
    header_intro: "The precious-metals trade carries serious legal and ethical responsibilities. Vissera treats compliance as a core competence — and a major trust signal for serious buyers.",
    note_eyebrow: "A NOTE ON OUR COMMITMENTS",
    note_body: "We list only the standards we genuinely follow. Specific Turkish regulatory references and any industry accreditations on our public materials are reviewed by qualified counsel — because in this industry, accurate compliance claims are both a legal requirement and a major trust signal for serious buyers.",
  },
  quality_page: {
    header_eyebrow: "QUALITY & CERTIFICATION",
    header_title_part1: "Quality you can",
    header_title_highlight: "verify",
    header_title_part2: "",
    header_intro: "In precious metals, trust is everything — so we never ask you to take purity on faith.",
  },
  trust_strip: [
    { icon: "ShieldCheck", title: "Investment-Grade Purity", text: "99.5%+ gold, 99.9%+ silver" },
    { icon: "FileCheck2", title: "Certified & Assayed", text: "Documentation with every shipment" },
    { icon: "Globe2", title: "Secure Global Logistics", text: "Insured, vaulted, tracked" },
    { icon: "Lock", title: "Compliant by Design", text: "Full KYC / AML and responsible-sourcing" },
  ],
  stats: [
    { value: "12+", label: "Years of Experience" },
    { value: "50+", label: "Countries Served" },
    { value: "250+", label: "Active Partners" },
    { value: "1,200+", label: "Shipments Completed" },
    { value: "$2B+", label: "Annual Volume Traded" },
  ],
  services: [
    { key: "import", title: "Import", short: "Bring investment-grade gold and silver into Turkey and partner markets — sourcing, customs, assay verification and secure delivery, end to end.", icon: "PackageCheck" },
    { key: "export", title: "Export", short: "Supply international buyers with certified bars, granules and coins — documentation, insured transport and compliant clearance at every border.", icon: "Globe" },
    { key: "sourcing", title: "Sourcing & Trading", short: "Connect buyers and sellers across our global network with competitive, transparent pricing benchmarked to live market rates.", icon: "Coins" },
    { key: "logistics", title: "Logistics & Vaulting", short: "Vetted specialist partners arrange fully insured, vaulted and tracked transport — with secure storage solutions where required.", icon: "Truck" },
    { key: "assay", title: "Assay & Verification", short: "Every lot independently verified for weight and fineness, with certificates so you always know exactly what you are receiving.", icon: "FlaskConical" },
    { key: "market", title: "Market Access", short: "Trusted intermediary providing market insight, fair valuations and efficient execution for spot and forward physical transactions.", icon: "LineChart" },
  ],
  products: [
    { title: "Gold Bars", desc: "Cast and minted, 1g to 12.5kg London Good Delivery", image: "goldBars", specs: ["100g, 250g, 500g, 1kg cast bars", "Minted bars 1g–100g", "Up to 12.5kg (400oz) LGD"] },
    { title: "Silver Bars", desc: "100g to 1,000oz industrial and investment formats", image: "silverBars", specs: ["100g, 500g, 1kg, 5kg cast bars", "1,000oz industrial bars", "99.9%+ purity"] },
    { title: "Coins & Bullion", desc: "Recognised sovereign and bullion coins", image: "coins", specs: ["Investment-grade bullion", "Sovereign issues", "Tamper-evident packaging"] },
    { title: "Granules & Grain", desc: "For refiners and jewellery manufacturers", image: "granules", specs: ["Gold and silver grain", "Industrial purities", "Custom packaging available"] },
  ],
  values: [
    { title: "Integrity", text: "We trade only metal we can verify, and we say exactly what we mean." },
    { title: "Transparency", text: "Clear pricing, clear documentation, no surprises." },
    { title: "Security", text: "Every shipment insured, tracked and handled by vetted partners." },
    { title: "Compliance", text: "We meet our obligations under Turkish law and international standards — without exception." },
    { title: "Partnership", text: "We measure success by the length of our client relationships." },
  ],
  markets: [
    { title: "Refineries", text: "Feedstock and finished product, sourced and supplied to specification." },
    { title: "Jewellery Manufacturers", text: "Granules, grain and bars for production." },
    { title: "Banks & Financial Institutions", text: "Investment-grade bullion for treasury and client needs." },
    { title: "Investment Firms & Funds", text: "Physical gold and silver positions." },
    { title: "Bullion Dealers & Wholesalers", text: "Reliable supply for resale." },
    { title: "Industrial Buyers", text: "Silver for manufacturing and technology applications." },
  ],
  process: [
    { n: "01", title: "Enquiry", text: "Tell us what you want to buy, sell or move — product, purity, quantity and destination." },
    { n: "02", title: "Quote", text: "Transparent pricing benchmarked to live market rates, plus terms." },
    { n: "03", title: "Onboarding", text: "KYC verification for both parties, in line with regulatory standards." },
    { n: "04", title: "Agreement", text: "Specifications, price, payment terms and delivery schedule confirmed in writing." },
    { n: "05", title: "Verification", text: "Metal is independently assayed and certified." },
    { n: "06", title: "Logistics", text: "Insured, tracked, secure transport with full customs clearance." },
    { n: "07", title: "Settlement", text: "You receive your metal with full documentation; payment settled per agreed terms." },
  ],
  faqs: [
    { q: "What products do you trade?", a: "Investment-grade and industrial gold and silver — bars, granules/grain and recognised bullion coins — in a range of weights and purities. Custom specifications are available on request." },
    { q: "What purities do you offer?", a: "Typically 99.5%+ for gold and 99.9%+ for silver, with higher purities available. Each lot is assayed and certified." },
    { q: "Which countries do you serve?", a: "We import and export across Europe, the Middle East, Asia and beyond from our base in Turkey. Tell us your destination and we'll confirm what's possible." },
    { q: "How is pricing determined?", a: "Pricing is benchmarked transparently to live international market rates, plus agreed margins and any logistics or duties. You receive a clear quote before committing." },
    { q: "How do you guarantee authenticity and purity?", a: "Every consignment is independently assayed and ships with certification and documentation." },
    { q: "How is the metal transported?", a: "Through vetted specialist partners, with full insurance, secure vaulting and end-to-end tracking." },
    { q: "What are your minimum order quantities?", a: "MOQs vary by product and market. Contact us to discuss your specific requirements." },
    { q: "Is your supply chain responsibly sourced?", a: "Yes. We apply due diligence aligned with recognised responsible-sourcing frameworks and trade only with vetted suppliers." },
  ],
  insights: [],
  quality_blocks: [
    { icon: "FlaskConical", title: "Independent Assay", text: "Every consignment is verified for weight and fineness through recognised assay procedures before it changes hands. You receive documentation confirming exactly what you are buying." },
    { icon: "FileCheck2", title: "Certification with Every Shipment", text: "Each lot ships with the relevant certificates — assay results, weight lists and origin documentation — giving you a clean, auditable record." },
    { icon: "GitBranch", title: "Sourcing Standards", text: "We source only from suppliers who meet our due-diligence requirements, supporting a responsible, conflict-free supply chain." },
    { icon: "ShieldCheck", title: "Quality Commitments", text: "Stated purity guaranteed and documented, accurate verified weights, tamper-evident professional packaging, and full traceability of documentation." },
  ],
  compliance_blocks: [
    { icon: "UserCheck", title: "Know Your Customer (KYC)", text: "We verify the identity and legitimacy of every counterparty before transacting, in line with Turkish regulations and international best practice." },
    { icon: "AlertCircle", title: "Anti-Money Laundering (AML)", text: "We maintain procedures to detect and prevent money laundering and the financing of illicit activity, including transaction monitoring and record-keeping consistent with applicable Turkish AML law." },
    { icon: "GitBranch", title: "Responsible & Conflict-Free Sourcing", text: "We are committed to a supply chain free from conflict, human-rights abuses and illegitimate origin, aligning our due diligence with the OECD Due Diligence Guidance for Responsible Supply Chains of Minerals from Conflict-Affected and High-Risk Areas." },
    { icon: "Scale", title: "Regulatory Compliance", text: "We operate under the applicable Turkish laws and regulations governing precious-metals trade, import and export, and comply with the customs and import/export rules of the jurisdictions we trade into." },
  ],
};
